import { useContext } from "react";
import { useSelector } from "react-redux";

import { Identifiable, Folder } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  folder: Identifiable<Folder>;
  retrieveDocumentTemplatesFolder(
    req: Boundaries["retrieveDocumentTemplatesFolder"]["request"],
  ): void;
}

function useRetrieveDocumentTemplatesFolder(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveDocumentTemplatesFolderRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveDocumentTemplatesFolderRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveDocumentTemplatesFolderRequestFailure,
    ),
    folder: useSelector(selector.getDocumentTemplatesFolder),
    retrieveDocumentTemplatesFolder: core.retrieveDocumentTemplatesFolder,
  };
}

export { useRetrieveDocumentTemplatesFolder };
